import {Injectable} from '@angular/core';
import {UsersService} from '../api/services/users.service';
import {MessagingAutomationService as ApiAutomationService} from '../api/services/messaging-automation.service';
import {AutomationModel, LookupModel} from '../api/models';
import {AdvancedMessagingService as ApiAdvancedMessagingService} from '../api/services/advanced-messaging.service';

@Injectable()
export class ProMessagingAutomationService {

  constructor(private apiUserService: UsersService,
              private apiAutomationService: ApiAutomationService,
              private apiMessagingService: ApiAdvancedMessagingService
  ) {

  }

  public async getContactsAndTags(searchText?: string) {
    return await this.apiMessagingService.proMessagingLookupContactsAndTags({q: searchText}).toPromise();
  }

  public async lookupPhoneNumbers(): Promise<LookupModel[]> {
    return await this.apiAutomationService.messagingAutomationLookupPhoneNumbers().toPromise();
  }

  public async getAutomationItem(id: string): Promise<AutomationModel> {
    return await this.apiAutomationService.messagingAutomationGetAutomationSettingsById({
      id: id,
    }).toPromise();
  }

  public async saveAutomation(model: AutomationModel): Promise<boolean> {
    await this.apiAutomationService.messagingAutomationSaveAutomationSetting({
      body: model
    }).toPromise();

    return true;
  }

  public async deleteAutomationItem(id: string): Promise<boolean> {
    await this.apiAutomationService.messagingAutomationDeleteAutomationSettingsById({
      id,
    }).toPromise();

    return true;
  }
}
